"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlmeAuthorizationApiBase = void 0;
const RequestInitHandler_1 = require("../RequestInitHandler");
class AlmeAuthorizationApiBase {
    constructor(logger, httpHandler, settings) {
        this.Logger = logger;
        this.HttpHandler = httpHandler;
        this.Settings = settings;
        this.AlmeBaseUri =
            `${this.Settings.AlmeApiProtocol}${this.Settings.AlmeApiHostname}${this.Settings.AlmeApiBasePath}`;
    }
    async PostAuthorizationAsync(authorizationRequest) {
        const authorizationRequestInfo = `${this.AlmeBaseUri}${this.Settings.AlmeApiAuthorizationEndpoint}`;
        const authorizationRequestInit = new RequestInitHandler_1.default(this.Logger, this.Settings, 'POST', JSON.stringify(authorizationRequest));
        const response = await this.HttpHandler.SendAsync(authorizationRequestInfo, authorizationRequestInit);
        if (typeof response !== 'object') {
            const error = new Error('Invalid Response');
            error.httpStatusCode = 401;
            throw error;
        }
        return response;
    }
}
exports.AlmeAuthorizationApiBase = AlmeAuthorizationApiBase;
//# sourceMappingURL=AlmeAuthorizationApiBase.js.map